import { ActionButton, ActionButtonType, LegacyCard } from "@octopusdeploy/design-system-components";
import type * as React from "react";
import styles from "./style.module.less";
interface LoadMoreCardProps {
    onLoadMore: () => void;
    onLoadAll: () => void;
    disableMargin?: boolean;
}
const LoadMoreCard: React.FC<LoadMoreCardProps> = (props) => {
    return (<LegacyCard className={styles.hoverlessContainer} logo={null} header={<ActionButton type={ActionButtonType.Secondary} label="Load more" onClick={(e) => props.onLoadMore()}/>} content={<div className={styles.content}>
                    Use filters to narrow the results (or{" "}
                    <a href="#" onClick={(e) => {
                e.preventDefault();
                props.onLoadAll();
            }}>
                        load all
                    </a>
                    )
                </div>} link={<div />} disableMargin={props.disableMargin}/>);
};
LoadMoreCard.displayName = "LoadMoreCard"
export default LoadMoreCard;
